<div
  class="d-flex flex-column justify-content-center align-items-center poppins"
>
  <div class="display-flex justify-content-center" *ngIf="!routeWizard">
    <h1 class="m-0 mb-3 poppins Title" translate>
      components.ingreso.conéctate a <span class="ms-0">Inviertis</span>
    </h1>
  </div>
  <div class="col-md-6 mw-100 mx-auto" style="max-width: 470px !important">
    <div class="card-body">
      <div class="text-center social-container">
        <button type="button" class="login-with-google-btn" translate>
          components.ingreso.Entrar con Google
        </button>

        <div id="idGoogleButton"></div>
        &nbsp;&nbsp;
        <div class="social facebook" (click)="loginWithFacebook()">
          <i class="fab fa-facebook fa-2x social-icons"></i>
          <span translate>components.ingreso.Entrar con Facebook</span>
        </div>
      </div>
      <br />
      <h4 class="poppins" translate>
        &nbsp;&nbsp; components.ingreso.o &nbsp;&nbsp;
      </h4>
      <form (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
        <div class="form-group">
          <label class="d-block login-fields"> Email </label>
          <input
            id="email-inp"
            type="email"
            class="form-control"
            formControlName="email"
            autocomplete="email"
            [placeholder]="'Email'"
          />
          <span hidden>Email</span>
          <small
            [hidden]="
              loginForm.controls.email.valid ||
              loginForm.controls.email.untouched
            "
            class="text-danger"
            translate
          >
            components.ingreso.El email es requerido
          </small>
          <label class="d-block login-fields" translate>
            components.ingreso.Contraseña
          </label>
          <div class="input-group">
            <input
              aria-describedby="btnGroupAddon"
              id="password-inp"
              class="form-control"
              [type]="showPassword ? 'password' : 'text'"
              formControlName="password"
              autocomplete="current-password"
              placeholder="{{ 'components.ingreso.Contraseña' | translate }}"
              required
            />
            <span
              class="input-group-text"
              id="basic-addon1"
              id="btnGroupAddon"
              (click)="hidePassword()"
              ><i class="fas fa-eye"></i
            ></span>
            <!-- <div class="input-group-append">
                            <div
                                    class="input-group-text"
                                    id="btnGroupAddon"
                                    (click)="hidePassword()"
                            >
                                <i class="fas fa-eye"></i>
                            </div>
                        </div> -->
          </div>
          <span hidden translate>components.ingreso.Contraseña</span>
          <small
            [hidden]="
              loginForm.controls['password'].valid ||
              loginForm.controls['password'].untouched
            "
            class="text-danger"
            translate
          >
            components.ingreso.La contraseña es requerida
          </small>
        </div>
        <p>
          <a
            class="recuperar-contraseña"
            [routerLink]="['../recover-password']"
            placement="bottom"
            translate
            >components.ingreso.¿Has olvidado tu contraseña?</a
          >
        </p>
        <button
          id="login-btn"
          class="btn btn-primary w-100 login-button"
          type="submit"
          [disabled]="loginForm.invalid || isLoading"
          (click)="buttonSpinnerHandler(1)"
        >
          <span translate>components.ingreso.Entrar</span>
          <i
            class="fas fa-circle-o-notch ms-1 fa-spin"
            [hidden]="!isLoading || spinnerDecider == 2"
          ></i>
        </button>
        <button
          *ngIf="!routeWizard"
          id="btn-registro"
          class="btn btn-outline-primary w-100 login-button social-login-btn"
          style="margin-top: -5px"
          (click)="
            buttonSpinnerHandler(2); redirectService.goToPage('/registrarse')
          "
        >
          <span translate>components.ingreso.¿No tienes usuario?</span>
          <i
            class="fas fa-circle-o-notch ms-1 fa-spin"
            [hidden]="!isLoading || spinnerDecider == 1"
          ></i>
        </button>
      </form>
    </div>
  </div>
</div>

<ng-template #modalActivation let-modal>
  <div class="container">
    <div class="col-12" style="padding: 20px 0 0 0">
      <button
        type="button"
        class="close"
        (click)="modal.dismiss('Close button click')"
      >
        &times;
      </button>
      <div class="text-center" style="padding: 20px 10px 5px 10px">
        <img
          src="favicon.ico"
          width="30"
          height="30"
          loading="lazy"
          alt="logo de inviertis"
        />
        <br /><br />
        <h1 class="title" translate>
          <strong translate> components.ingreso.title1 </strong>
        </h1>
      </div>
      <div style="padding: 8px 10px 5px 10px">
        <p translate>
          <strong translate>components.ingreso.subtitle1</strong><br />
          components.ingreso.subtitle2
        </p>

        <p translate>
          components.ingreso.text1 <br />
          <a (click)="visibilityForm = !visibilityForm" class="azul" translate
            >components.ingreso.text2</a
          >
        </p>
        <div class="row">
          <div class="col-md-12">
            <div [formGroup]="SendEmailForm" *ngIf="visibilityForm">
              <input
                type="text"
                placeholder="{{
                  'components.ingreso.placeholderEmail' | translate
                }}"
                formControlName="email"
                style="width: 100%"
                class="form-control"
              />
              <small
                *ngIf="
                  submitted && SendEmailForm.controls['email'].errors?.required
                "
                class="text-danger"
                translate
              >
                components.ingreso.El email es requerido
              </small>
              <small
                *ngIf="
                  submitted && SendEmailForm.controls['email'].errors?.pattern
                "
                class="text-danger"
                translate
              >
                components.stepBasics.enterValidEmail
              </small>
              <div class="pull-right">
                <button
                  id="btn-general-register"
                  class="btn btn-blue"
                  style="margin-top: 5%"
                  translate
                  [disabled]="disabledButton"
                  (click)="reSendEmail()"
                >
                  components.ingreso.Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="margin-top: 1rem">
          <small style="color: #828282; font-size: 14.5px" translate>
            components.ingreso.footer1
          </small>
          <a
            [routerLink]="['/' + translateService.currentLang + '/sobre-nosotros/contacto']"
            (click)="modal.dismiss('Close button click')"
            translate
            >components.ingreso.footer4</a
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
